<template>
  <div id="scene-container" ref="sceneContainer"></div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
// import Stats from 'stats.js'

export default {
  name: 'USBScene',
  data () {
    return {
      // stats: null
    }
  },
  mounted () {
    this.init()

    // Listen for the resize event
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    // Clean up the event listener
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // Update the aspect ratio
      this.camera.aspect = this.container.clientWidth / this.container.clientHeight
      this.camera.updateProjectionMatrix()

      // Update the renderer size
      this.renderer.setSize(this.container.clientWidth, this.container.clientHeight)
    },
    init () {
      this.container = null;
      this.scene = null;
      this.camera = null;
      this.controls = null;
      this.renderer = null;

      // set container
      this.container = this.$refs.sceneContainer

      // add stats
      // this.stats = new Stats()
      // this.container.appendChild(this.stats.dom)

      // add camera
      const fov = 60 // Field of view
      const aspect = this.container.clientWidth / this.container.clientHeight
      const near = 0.1 // the near clipping plane
      const far = 30 // the far clipping plane
      const camera = new THREE.PerspectiveCamera(fov, aspect, near, far)
      // camera.position.set(0, 5, 10)
      camera.position.set(0, 10, -2.5);
      this.camera = camera
      this.camera.up.set(0, 0, 1)

      // create scene
      this.scene = new THREE.Scene()
      //this.scene.background = new THREE.Color('transparent')
      // this.scene.background = new THREE.Color( 0xff0000 );

      // add lights
      const ambientLight = new THREE.AmbientLight(0xffffff, 4.0);
      this.scene.add(ambientLight);

      // previous ambient light 
      // const ambientLight = new THREE.HemisphereLight(
      //   0xffffff, // bright sky color
      //   0x222222, // dim ground color
      //   1 // intensity
      // )

      const mainLight = new THREE.DirectionalLight(0xffffff, 4.0)
      mainLight.position.set(-10, 8, 15)
                         //  to up,  toward you,  to right 
      this.scene.add(mainLight);

      const mainLight2 = new THREE.DirectionalLight(0xffffff, 10.0)
      mainLight2.position.set(-10, -10, -10)
      this.scene.add(mainLight2);

      // add controls
      this.controls = new OrbitControls(this.camera, this.container)
      this.controls.enableZoom = false
      this.controls.enableDamping = true
      this.controls.autoRotate = true
      this.controls.autoRotateSpeed = 6

      // create renderer
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
      this.renderer.setSize(this.container.clientWidth, this.container.clientHeight)
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.gammaOutput = true
      this.renderer.gammaFactor = 2.2
      this.renderer.outputEncoding = THREE.sRGBEncoding
      this.renderer.physicallyCorrectLights = true
      this.container.appendChild(this.renderer.domElement)

      // add environment
      this.pmremGenerator = new THREE.PMREMGenerator(this.renderer);
      this.pmremGenerator.compileEquirectangularShader();
      let neutralEnvironment = this.pmremGenerator.fromScene(new RoomEnvironment()).texture;
      this.scene.environment = neutralEnvironment;
      this.renderer.toneMapping = THREE.ReinhardToneMapping;
      // this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
      // this.renderer.toneMappingExposure = Math.pow(2, -1); // -1 is the value to change

      // set aspect ratio to match the new browser window aspect ratio
      this.camera.aspect = this.container.clientWidth / this.container.clientHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.container.clientWidth, this.container.clientHeight)

      const loader = new GLTFLoader()

      loader.load(
        '/models/usb-sample-7-1b.glb',
        gltf => {
          gltf.scene.scale.set(12, 12, 12) // Adjust the scale values as needed
          // gltf.scene.rotation.y = Math.PI * 1.75
          gltf.scene.rotation.y = Math.PI * 0.7
          this.scene.add(gltf.scene)
        },
        undefined,
        undefined
      )

      this.renderer.setAnimationLoop(() => {
        this.render()
      })
    },
    render () {
      this.renderer.render(this.scene, this.camera)
      this.controls.update();
      // this.stats.update()
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#scene-container {
  height: 100%;
  min-height: 300px;
  cursor: grab;
  outline: none;
}

#scene-container:active {
  cursor: grabbing;
}

@media screen and (max-width: 700px) {
  #scene-container {
    pointer-events: none;
  }
}
</style>